import React from 'react';

interface SectionHeaderProps {
  index?: string;
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  index,
  eyebrow,
  title,
  description,
  align = 'left',
}) => {
  return (
    <header className={`section__header section__header--${align}`}>
      <div className="section__kicker">
        {index && (
          <span className="section__index" aria-label={`Sección ${index}`}>
            {index}
          </span>
        )}
        <p className="section__eyebrow">{eyebrow}</p>
      </div>
      <h2 className="section__title">{title}</h2>
      {description && <p className="section__subtitle">{description}</p>}
    </header>
  );
};

export default SectionHeader;
